import { useRoutePermission as usePgRoutePermission } from "@polargold/pg-frontend-vue";
import { useAuthUserStore } from "@/stores/authUserStore";
import { ROUTE } from "@/router/routeDefinitions.ts";

/**
 * Thin wrapper pinning this app's auth-store shape onto `pg-frontend-vue`'s
 * `useRoutePermission`. `isAdmin` reads `authUser.isAdmin` directly (so the `AutoQAdmin`
 * role does not count as admin here) - matches this app's original `usePermission` exactly.
 *
 * No `onNavigationError` - the original silently swallowed a failed permission-redirect
 * rather than reporting/falling back, and this preserves that.
 */
export const useRoutePermission = () => {
    const authUserStore = useAuthUserStore();

    return usePgRoutePermission({
        getUserRoles: () => authUserStore.authUser?.roles ?? [],
        isAdmin: () => authUserStore.authUser?.isAdmin ?? false,
        isAuthUserLoaded: () => authUserStore.authUserIsReady,
        notAllowedRouteName: ROUTE.PRODUCT_SEARCH.NAME,
    });
};
